
// SVG Icon: sphere
export default { id: "terriajs-sphere" };
export const id = "terriajs-sphere";
export const name = "sphere";
